var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedinOutline = function SvgLinkedinOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#666664",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75,
    d: "M14 7a5.25 5.25 0 0 1 5.25 5.25v6.125h-3.5V12.25a1.75 1.75 0 0 0-3.5 0v6.125h-3.5V12.25A5.25 5.25 0 0 1 14 7ZM5.25 7.875h-3.5v10.5h3.5v-10.5ZM3.5 5.25a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z"
  })));
};
export default SvgLinkedinOutline;